<template>
  <div>
    <div class="pe_form-container" v-if="!this.success">

      <h1>Congratulations!</h1>
      <p>You've completed the puzzle</p>
      <p><strong>Enter for your chance to win</strong></p>
      <!--<p>Complete the form below to be entered into the monthly draw to win a AUD$100 Visa card</p>-->
      <label for="name">Name *
        <span v-if="formErrors && formErrors.name" class="error">
          {{ formErrors.name }}
        </span>

      </label>

      <input type="text" v-model="name" :class="{ 'error': formErrors && formErrors.name }" @keyup="validateFormOnKey()"
        autocomplete="name">


      <label for="email">Email *
        <span v-if="formErrors && formErrors.email" class="error">
          {{ formErrors.email }}
        </span>

      </label>
      <input type="email" v-model="email" :class="{ 'error': formErrors && formErrors.email }"
        @keyup="validateFormOnKey()" autocomplete="email">

      <label for="country">Country *
        <span v-if="formErrors && formErrors.email" class="error">
          {{ formErrors.country }}
        </span>

      </label>
      <select required v-model="country">
        <option value="">Select an option...</option>
        <option value="Australia">Australia</option>
        <option value="New Zealand">New Zealand</option>
        <option value="United Kingdom">United Kingdom</option>
        <option value="Other">Other</option>
      </select>

      <button v-if="!this.success" class="pe_form_submit_button" type="submit"
        @click.prevent="submitForm()">Submit</button>
      <p v-if="this.apiResponse != ''">Thank you for entering the competition</p>
    </div>

    <div class="pe_form-container" v-if="this.success">
      <div v-if="this.success">
        <Logo style="width:70px;" />
        <h1>Thank you for entering</h1>
        <h2>Good luck!</h2>

        <p class="mt-10"><strong>Solve time:</strong> {{ myTotalTime(totalTime, hintsUsed) }}</p>
        <p><strong>Your best time:</strong> {{ myBestTime(game.puzzleBestTime, totalTime, hintsUsed) }}</p>
      </div>

      <div v-if="this.success" :class="['pe_completedmodal_row pe_mt_1', compButtonsSpacerClass]">
        <a :class="['pe_completedmodal_btn', gameClasses]"
          href="https://lovattspuzzles.com/online-puzzles-competitions/">
          Try Our Other Puzzles
        </a>

      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import debounce from 'throttle-debounce'

import Spinner from '@puzzleapps/shared/src/components/ui/Spinner'

import api from '@puzzleapps/shared/src/utils/api'
import Logo from '@puzzleapps/shared/src/components/ui/logos/Heart'

export default {
  name: 'competition-modal',
  props: ['date'], // date, format YYYY-MM-DD

  components: {
    Spinner,
    Logo,
  },

  data() {
    return {
      formErrors: null,
      name: '',
      email: '',
      country: '',
      EMAIL_REGEXP: /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i,
      lastError: null,
      apiResponse: '',
      apiLoading: null,
      success: false,
    }
  },

  mounted() {
    this.lastError = JSON.stringify(this.stateError)
    this.clearError()
  },


  methods: {
    ...mapActions({
      clearError: 'errors/clearError'
    }),
    validateFormOnKey() {
      if (!this.errors) return

      this.validateForm()
    },

    validateForm() {
      let totalErrors = 0

      this.formErrors = {
        name: '',
        email: '',
        message: '',
        country: '',
      }

      for (let key in this.formErrors) {
        if (this[key] == '') {
          this.formErrors[key] = 'Field is required'
          totalErrors++
        }
      }

      if (
        this.email != "" &&
        (this.email.length <= 5 || !this.EMAIL_REGEXP.test(this.email))
      ) {
        this.formErrors.email = 'Incorrect email format'
        totalErrors++
      }


      return (totalErrors === 0)
    },

    submitForm() {
      let isValid = this.validateForm()

      if (!isValid) {

        return
      }

      let body = {
        //   clientAppId: this.clientAppId,
        ClientScheduleId: this.game.puzzleId,
        CompetitionId: this.game.competitionID,
        PlayId: this.game.playId,
        Name: this.name,
        Email: this.email,
        Country: this.country,
        userAgent: navigator.userAgent,
      }

      if (process.env.NODE_ENV === 'development') {
        console.log(body)
      }

      this.apiLoading = true

      api.enterCompetion(body)
        .then(res => {
          this.success = true
          this.apiResponse = res.message

        })
        .catch(err => {
          this.apiResponse = 'Error submitting entry: ' + err.message
          this.success = true
        })
        .finally(() => this.apiLoading = false)
    },
    secondsToHms(seconds) {
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const secondsRemainder = seconds % 60;
      const hoursString = hours.toString().padStart(2, '0');
      const minutesString = minutes.toString().padStart(2, '0');
      const secondsString = secondsRemainder.toString().padStart(2, '0');

      if (hours > 0)
        return `${hoursString}:${minutesString}:${secondsString}`;
      else
        return `${minutesString}:${secondsString}`;

    },
    myTotalTime(tTime, hintCount) {
      let penaltyMultiplier = 10000

      if (this.gameType === 'sudoku')
        penaltyMultiplier = 15000

      let totalTime = tTime + (penaltyMultiplier * hintCount)
      return this.secondsToHms(Math.floor(totalTime / 1000))

    },
    myBestTime(bTime, tTime, hintCount) {
      let penaltyMultiplier = 10000

      if (this.gameType === 'sudoku')
        penaltyMultiplier = 15000

      let penaltyTime = tTime + (penaltyMultiplier * hintCount)

      if (bTime > 0) {
        if (penaltyTime < bTime) {
          return this.secondsToHms(Math.floor(penaltyTime / 1000))
        }
        else {
          return this.secondsToHms(Math.floor(bTime / 1000))
        }
      }
      else {
        return this.secondsToHms(Math.floor(penaltyTime / 1000))
      }

    }
  },
  computed: {
    ...mapState({
      game: state => state.game,
      clientAppId: state => state.clientAppId || window.PE_CLIENTAPP_ID,
      stateError: state => state.errors.error,
      bestTime: state => state.game.puzzleBestTime,
      totalTime: state => state.game.totalTime,
      hintsUsed: state => state.game.hintsUsed,
    }),

    gameClasses() {
      let classes = {
        [this.game.type]: true,

      }
      return classes
    },

    compButtonsSpacerClass() {
      let classes = {
        ['pe_mt_2']: this.compID > 0 ? true : false, // bigger spacing if it is the competition display
        ['pe_mt_1']: this.compID == 0 ? true : false,
      }
      return classes
    },
  }
}

</script>

<style scoped lang="scss">
@import '@puzzleapps/shared/src/style/completedModal2';

#puzzleapp {
  .pe_formmodal_close-button {
    align-self: flex-end;
    padding: 10px;
    cursor: pointer;
    text-align: right;
    font-size: 1.5em;
  }

  h1,
  h2 {
    color: #fff !important;
  }

  h1 {
    font-size: 2.2em;
  }

  .pe_formmodal {

    position: absolute;
    width: 100%;
    max-width: 100%;
    //top: 1%;
    //left: 1%;
    right: 0;
    top: 0;
    height: 100%;
    background: var(--modal-background);
    color: #fff;
    z-index: 30;
    overflow: auto;

  }

  .pe_form-container {
    display: flex;
    flex-direction: column;
    gap: 4px;
    max-width: 500px;
    margin: 0 auto;
    padding: 0 8px;

    h1 {
      margin-top: 10px !important;
    }
  }

  p.mt-10 {
    margin-top: 10px;
  }

  select {
    font-family: Poppins, Helvetica, Arial, sans-serif !important;
  }

  .pe_form-container label {
    //font-weight: bold;
    color: #fff;
    text-align: left;
    padding: 0 5px;
    font-size: 0.8em;
    margin-top: 5px;
  }

  .pe_form-container input[type="text"],
  .pe_form-container input[type="email"],
  .pe_form-container textarea,
  .pe_form-container select {
    border-radius: 4px;
    border: 1px solid #ccc;
    padding: 5px;
    width: 100%;

    &.error {
      background: #f38c8c;

    }

    option {


      .error {
        background-color: #f38c8c;
      }

    }
  }

  .pe_form-container p {
    color: #fff;
    font-weight: 400;
    font-size: 1em;
  }

  .pe_form-container button {
    border-radius: 5px;
    padding: 10px;
    margin-top: 5px;
    background: var(--crossword-menu-btn-background);
    color: var(--crossword-menu-btn-color);
    cursor: pointer;

    &:hover {
      background: var(--crossword-menu-btn-hover);
      color: #000;
    }
  }

  .pe_form-container span {
    &.error {
      color: #f87272;

    }

  }

  .pe_form_submit_button {
    // border-radius: 5px;
    // padding: 10px;
    // background: var(--crossword-menu-btn-background);
    // color: var(--crossword-menu-btn-color);
    // cursor: pointer;
    font-family: Poppins, Helvetica, Arial, sans-serif;
    font-weight: 600;
  }

  .pe_logo {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 70px;
    height: 70px;
  }
}
</style>